<!--
Different
异形制品
-->


<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="异形制品" name="异形制品">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="different">
              <el-form-item label> 
                <p>请描述您的需求</p>
                <el-alert
                  title="如挂件立牌包装，腰封，硫酸纸信封，PVC信封，纸盒，纸质海报盒，PVC海报盒，PVC包装盒，PVC外书封（信封/不印刷）等请尽量清楚的文字描述您的所使用的材料，尺寸，特殊工艺，款式和理想中成品的样子等需求"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 20px 0 0 0;"
                ></el-alert>
                <el-input type="textarea" v-model="different['需求描述']" style="margin-top:20px"></el-input>
              </el-form-item>
              <center>
                <el-button v-on:click="addEvent()">提交</el-button>
                <el-button v-on:click="clear()">清空</el-button>
              </center>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "PvcStickers",
  data() {
    return {
      forcollapse: ["allsame"],
      different: {
        title: "异形制品"
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.different);
    }, 
    clear() {
      this.$root.clearAlert();
      this.different = {
        title: "异形制品"
      };
    }
  }
};
</script>
<style scoped>
</style>